import  { useState, useEffect,useContext  } from "react";
import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import LoaderComponent from "../../components/LoaderComponent";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import showSubscriptionToast from "./SubscriptionToast"
import ConfirmDialog from "../../components/ConfirmDialog ";
import {useFintechLayouts, useBillingAddresseslMutation,useConsumerProfileData,searchSubscription} from '../../services/AsaApiServices'
import {useIsLoading} from '../../services/AsaSessionServices'
import { useTranslation } from "react-i18next";
import { AsaStateContext } from '../../components/AsaStateProvider'
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
interface IAddressInput{
  country: string,
  firstName: string,
  lastName: string,
  streetAddress: string,
  aptSuite: string,
  city: string,
  state: string,
  zipCode: string,
}
const defaultInput:IAddressInput={
  country: "",
  firstName: "",
  lastName: "",
  streetAddress: "",
  aptSuite: "",
  city: "",
  state: "",
  zipCode:""
}

const BillingAddressScreen = () => {
  const { t } = useTranslation();
  const billinAddressMutation=useBillingAddresseslMutation()
  const layout=useFintechLayouts()
  const [asastate, ] = useContext(AsaStateContext)
  const [isLoading, setIsLoading] = useIsLoading();
  const isDarkMode= asastate?.isDarkMode??false;
 
  // Theme variables for light / dark mode
  const theme = {
    pageText: isDarkMode ? "#FFFFFF" : "#111827",
    panelBg: isDarkMode ? "#121212" : "#EBECF0",
    panelInnerBg: isDarkMode ? "#121212" : "#EBECF0",
    inputBg: isDarkMode ? "#121212" : "#EBECF0",
    inputBorderEmpty: isDarkMode ? "rgba(255,255,255,0.5)" : "#4E4E4E",
    inputBorderFilled: isDarkMode ? "#EBECF0" : "#000000",
    labelBg: isDarkMode ? "#121212" : "#EBECF0",
    errorText: "#ef4444",
    buttonText: isDarkMode ? "#FFFFFF" : "#EBECF0",
  };
  // to do optimize to call when is new
  const {data:consumerProfileData} = useConsumerProfileData();
  //------------------------
  const [inputs, setInputs] = useState({...defaultInput});

  const [errors, setErrors] = useState({...defaultInput});

  const [isFormFilled, setIsFormFilled] = useState(false);
  const location = useLocation();
  const { state } = location;
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  // Check if state is defined and extract the address object
  const address = state?.address;
  const returnurl = state?.returnurl??"/subscriptionpayment";
  const navigate = useNavigate();

  const handleInputChange = (e: { target: { id: any; value: any } }) => {
    const { id, value } = e.target;
    setInputs({ ...inputs, [id]: value });
    setErrors({ ...errors, [id]: "" }); // Clear error when user starts typing
  };

  const handleCancel = () => {
    setInputs({...defaultInput});
    setErrors({...defaultInput});
    navigate(-1);
  };

  useEffect(() => {
    setIsFormFilled(
      !!(
        inputs.country &&
        inputs.firstName &&
        inputs.lastName &&
        inputs.streetAddress &&
        inputs.city &&
        inputs.state &&
        inputs.zipCode
      )
    );
  }, [inputs]);

  const handleBackClick = () => {
    if (!!!returnurl ) {
      navigate(-1); // Navigate back to the previous page in the browser history
    } else  {
      
      navigate(returnurl,{replace:true}); // This will navigate back to the previous page in the browser history
    }
  };
  useEffect(() => {
    if (!!consumerProfileData && !!!address) {  
     // set defaults for new screen
      setInputs({...inputs,...
          {firstName:consumerProfileData.firstName,
            lastName:consumerProfileData.lastName,
            country:consumerProfileData.country
           // streetAddress:consumerProfileData.address,
           // aptSuite:consumerProfileData.address2,
           // city:consumerProfileData.city,
           // state:consumerProfileData.state,
           // zipCode:consumerProfileData.postalCode,
          }})
      
    } 
  }, [consumerProfileData]);

  useEffect(() => {
    AnalyticsService.track(
      address ? "Edit Billing Address Viewed" : "Add Billing Address Viewed",
      AnalyticsAction.View,
      AnalyticsFeature.BillingAddress
    );
  }, []);

  useEffect(() => {
    if (address) {
      const copy={} as IAddressInput
      Object.keys(inputs).forEach((key) => {
        if (key in inputs) {
          copy[key] = address[key];   
        }
      });
      copy.streetAddress=address.address1
      copy.aptSuite=address.address2
      //setInputs({...inputs,...address})
      setInputs({...inputs,...copy})
      
    } 
  }, [address]);

  const handleSave = async () =>{
    if(address){
      const searchBody={
        billingAddressId: address?.consumerAddressId,
        subscriptionStatus: "Active",
      }
      try {
        setIsLoading(true);
        const affectedSubscription=await searchSubscription(asastate,searchBody)
        if( affectedSubscription && affectedSubscription.length > 0){
          setShowConfirmDialog(true);
          return;
        }
      }
      catch (error) {
        console.error("Error searching subscription:", error);
        showSubscriptionToast(t("errorSearchingSubscription"), true);
        
      }
      finally {
        setIsLoading(false);
      }
    }
    await handleSaveConfirmed();
  }
  const handleSaveConfirmed = async () => {
    // Implement validation checks here
    if (validateForm()) {

        const requestData = [
          {
            consumerAddressId: (address?.consumerAddressId)??0,
            address1: inputs.streetAddress,
            address2: inputs.aptSuite || null,
            city: inputs.city,
            state: inputs.state,
            zipCode: inputs.zipCode,
            isCurrent: false,
            isActive: true,
            moveoutDate: null,
            isBilling: true,
            Country: inputs.country,
            FirstName: inputs.firstName,
            LastName: inputs.lastName,
            isPrimary: false,
            isShipping: false,
            addressType: null,
          },
        ];
        try{
          var res=await billinAddressMutation.mutateAsync(requestData)
          AnalyticsService.track(
            address ? "Billing Address Updated" : "Billing Address Added",
            AnalyticsAction.Click,
            AnalyticsFeature.BillingAddress
          );
          handleBackClick();
        }
        catch(error){
          AnalyticsService.track("Billing Address Save Error", AnalyticsAction.API_Result, AnalyticsFeature.BillingAddress);
            showSubscriptionToast((error as Error)?.message,true)
        }

    } else {
      console.log("Form validation failed.");
    }
  };

  const validateForm = () => {

    let valid = true;
    const newErrors: typeof errors = { ...errors };
   
    // Check for required fields
    (Object.keys(inputs) as Array<keyof typeof inputs>).forEach((key) => {
      if (!inputs[key] && key !== "aptSuite") {

        newErrors[key] = t("fieldRequired",{field:t(key)})//`${key} is required`;
        valid = false;
      }
    });

    // Check if zipCode is numeric
    if (inputs.zipCode && !/^\d+$/.test(inputs.zipCode)) {
      newErrors.zipCode = "Zip code must be numeric";
      valid = false;
    }
   
    setErrors(newErrors);

    return valid;
  };


  return (
    <div className={`h-screen flex flex-col text-center pt-10 relative`} 
      style={{
      ...layout?.backGroundStyle,
      color: theme.pageText,
      background: layout?.backGroundStyle?.background ?? (isDarkMode ? "linear-gradient(180deg,#705AE2,#490C95)" : "#f6f7fb")
      }}
    >
            {showConfirmDialog && (
        <ConfirmDialog
          title={t("updateAddressTitle")}
          message={t("updateAddressMessage")}
          onCancel={() => {
          setShowConfirmDialog(false);
          
          }}
          onConfirm={() => {
          // Handle confirm logic here
          setShowConfirmDialog(false); // Close dialog after action
          handleSaveConfirmed();
        }}
          isOpen={showConfirmDialog}
          confirmButtonText={t("update")}
          cancelButtonText={t("cancel")}
        />
      )}
      {isLoading && <LoaderComponent />}{" "}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <img
            className="w-6 h-6 sm:w-8 sm:h-8 ml-5"
            src={arrow_back_ios_new}
            alt="Back"
            onClick={handleBackClick}
          />
        </div>

        <p className="custom-style-bugs text-center flex-grow">
          {!!!address ? t("addAddress") : t("editAddress")}
        </p>
        <div className="w-6 h-6 sm:w-8 sm:h-8 ml-5"></div>
      </div>
      <div className="bg-[#EBECF0] dark:bg-[#121212] w-full  rounded-t-3xl shadow-md p-6 mt-10 more-rounded"
        
      >
        <form className="mt-5">
          <div className="mb-10 relative border-white">
            <label
              className={`absolute transition-all font-poppins font-semibold duration-300 ease-in-out transform left-3 px-1 ${
                inputs.country
                  ? "top-[-15px] scale-75 label-shrink-address"
                  : errors.country
                    ? "top-[-10px] -translate-y-1/2 label-expand"
                    : "top-1/2 -translate-y-1/2 label-expand"
              }`}
              htmlFor="country"
              style={{
                fontSize: errors.country
                  ? "1rem"
                  : inputs.country
                    ? "1.25rem"
                    : "1rem",
                backgroundColor: theme.labelBg,
                color: theme.pageText,
              }}
            >
              {t("country")}
            </label>
            <input
              type="text"
              id="country"
              className={`input-address mt-6 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-4 pr-3`}
              placeholder=" "
              style={{
                backgroundColor: theme.inputBg,
                borderColor: inputs.country ? theme.inputBorderFilled : theme.inputBorderEmpty,
                color: theme.pageText,
              }}
              value={inputs.country}
              onChange={handleInputChange}
            />
            {errors.country && (
              <p
                className="text-left text-xs absolute"
                style={{ left: "10px", color: theme.errorText }}
              >
                {errors.country}
              </p>
            )}
          </div>
          <div className="mb-10 relative">
            <label
              className={`absolute transition-all duration-300 ease-in-out transform left-2 bg-[#121212] px-1 font-poppins ${
                inputs.firstName
                  ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address"
                  : errors.firstName
                    ? "top-[-10px] text-[#FFFFFF] -translate-y-1/2 label-expand"
                    : "top-1/2 text-[#FFFFFF] -translate-y-1/2 label-expand"
              }`}
              htmlFor="firstName"
              style={{
                backgroundColor: theme.labelBg,
                color: theme.pageText,
                fontSize: errors.firstName
                  ? "1rem"
                  : inputs.firstName
                    ? "1.25rem"
                    : "1rem", // Font size based on error or input state
              }}
            >
             {t("firstName")}
            </label>
            <input
              type="text"
              id="firstName"
              className={`input-address mt-1 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                inputs.firstName ? "text-[#FFFFFF]" : ""
              }`}
              style={{
                backgroundColor: theme.inputBg,
                borderColor: inputs.firstName
                  ? theme.inputBorderFilled
                  : theme.inputBorderEmpty,
                color: theme.pageText,
              }}
              value={inputs.firstName}
              onChange={handleInputChange}
            />
            {errors.firstName && (
              <p
                className="text-red-500 text-left text-xs absolute"
                style={{ left: "10px" }}
              >
                {errors.firstName}
              </p>
            )}
          </div>

          <div className="mb-10  relative">
            <label
              className={`absolute transition-all duration-300 ease-in-out transform left-2 bg-[#121212] px-1 font-poppins ${
                inputs.lastName
                  ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address"
                  : errors.lastName
                    ? "top-[-10px] text-[#FFFFFF] -translate-y-1/2 label-expand"
                    : "top-1/2 text-[#FFFFFF] -translate-y-1/2 label-expand"
              }`}
              htmlFor="lastName"
              style={{
                backgroundColor: theme.labelBg,
                color: theme.pageText,

                fontSize: errors.lastName
                  ? "1rem"
                  : inputs.lastName
                    ? "1.25rem"
                    : "1rem", // Font size based on error or input state
              }}
            >
              {t("lastName")}
            </label>
            <input
              type="text"
              id="lastName"
              className={`input-address mt-1 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                inputs.lastName ? "text-[#FFFFFF]" : ""
              }`}
              style={{
                backgroundColor: theme.inputBg,
                borderColor: inputs.lastName
                  ? theme.inputBorderFilled
                  : theme.inputBorderEmpty,
                color: theme.pageText,
              }}
              value={inputs.lastName}
              onChange={handleInputChange}
            />
            {errors.lastName && (
              <p
                className="text-red-500 text-left text-xs absolute"
                style={{ left: "10px" }}
              >
                {errors.lastName}
              </p>
            )}
          </div>

          <div className="mb-10 relative">
            <label
              className={`absolute transition-all duration-300 ease-in-out transform label-left bg-[#121212] font-poppins ${
                inputs.streetAddress
                  ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address left-[-10px]" // Move label further left when shrunk
                  : errors.streetAddress
                    ? "top-[-10px] text-[#FFFFFF] -translate-y-1/2 label-expand"
                    : "top-1/2 text-[#FFFFFF] -translate-y-1/2 label-expand"
              }`}
              htmlFor="streetAddress"
              style={{
                backgroundColor: theme.labelBg,
                color: theme.pageText,

                fontSize: errors.streetAddress
                  ? "1rem"
                  : inputs.streetAddress
                    ? "1.25rem"
                    : "1rem",
                zIndex: 1,
                left: inputs.streetAddress ? "5px" : "", // Adjust left positioning when label is shrunk
              }}
            >
             {t("streetAddress")}
            </label>
            <input
              type="text"
              id="streetAddress"
              className={`input-address mt-4 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                inputs.streetAddress ? "text-[#FFFFFF]" : ""
              }`}
              style={{
                backgroundColor: theme.inputBg,
                borderColor: inputs.streetAddress
                  ? theme.inputBorderFilled
                  : theme.inputBorderEmpty,
                color: theme.pageText,
                paddingTop: "0.75rem", // Adjusted padding for vertical centering
                paddingBottom: "0.75rem", // Ensures equal padding on top and bottom
                lineHeight: "1.25rem", // Line height to help with vertical centering
                boxSizing: "border-box", // Includes padding and border in the element's total width and height
              }}
              value={inputs.streetAddress}
              onChange={handleInputChange}
              placeholder=" " // Placeholder should be empty
            />
            {errors.streetAddress && (
              <p
                className="text-red-500 text-left text-xs absolute"
                style={{ left: "10px" }} // Adjust positioning for error message
              >
                {errors.streetAddress}
              </p>
            )}
          </div>

          <div className="mb-10 relative">
            <label
              className={`absolute transition-all duration-300 ease-in-out transform left-2 bg-[#121212] font-poppins ${
                inputs.aptSuite
                  ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address left-[-10px]" // Move label further left when shrunk
                  : errors.aptSuite
                    ? "top-[-0.75rem] text-[#FFFFFF] -translate-y-1/2 label-expand"
                    : "top-1/2 text-[#FFFFFF] -translate-y-1/2 label-expand"
              }`}
              htmlFor="aptSuite"
              style={{
                backgroundColor: theme.labelBg,
                color: theme.pageText,

                fontSize: errors.aptSuite
                  ? "1rem"
                  : inputs.aptSuite
                    ? "1.25rem"
                    : "1rem", // Font size based on error or input state
                zIndex: 1, // Ensure label stays above other elements
                left: inputs.aptSuite ? "-2px" : "", // Adjust left positioning when label is shrunk
              }}
            >
              {t("aptSuite")}
            </label>
            <input
              type="text"
              id="aptSuite"
              className={` input-address mt-4 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                inputs.aptSuite ? "text-[#FFFFFF]" : ""
              }`}
              style={{
                backgroundColor: theme.inputBg,
                borderColor: inputs.aptSuite
                  ? theme.inputBorderFilled
                  : theme.inputBorderEmpty,
                color: theme.pageText,
                paddingTop: "0.75rem", // Adjusted padding to center text vertically
                paddingBottom: "0.75rem", // Ensures equal padding on top and bottom
                boxSizing: "border-box", // Includes padding and border in the element's total width and height
              }}
              value={inputs.aptSuite}
              onChange={handleInputChange}
              placeholder=" " // Placeholder should be empty
            />
            {errors.aptSuite && (
              <p
                className="text-red-500 text-left text-xs absolute"
                style={{ left: "10px" }} // Adjust positioning for error message
              >
                {errors.aptSuite}
              </p>
            )}
          </div>

          <div className="mb-10  relative">
            <label
              className={`absolute transition-all duration-300 ease-in-out transform left-2 bg-[#121212] px-2 font-poppins ${
                inputs.city
                  ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address"
                  : errors.city
                    ? "top-[-0.75rem] text-[#FFFFFF] -translate-y-1/2 label-expand" // Adjusted position when there's an error
                    : "top-1/2 text-[#FFFFFF] -translate-y-1/2 label-expand"
              }`}
              htmlFor="city"
              style={{
                backgroundColor: theme.labelBg,
                color: theme.pageText,

                fontSize: errors.city
                  ? "1rem"
                  : inputs.city
                    ? "1.25rem"
                    : "1rem", // Font size based on error or input state
                zIndex: 1, // Ensure label stays above other elements
              }}
            >
              {t("city")}
            </label>
            <input
              type="text"
              id="city"
              className={`input-address block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                inputs.city ? "text-[#FFFFFF]" : ""
              }`}
              style={{
                backgroundColor: theme.inputBg,
                borderColor: inputs.city
                  ? theme.inputBorderFilled
                  : theme.inputBorderEmpty,
                color: theme.pageText,
                paddingTop: "0.75rem", // Adjusted padding for vertical centering
                paddingBottom: "0.75rem", // Ensures equal padding on top and bottom
                lineHeight: "1.25rem", // Line height to help with vertical centering
                boxSizing: "border-box", // Includes padding and border in the element's total width and height
              }}
              value={inputs.city}
              onChange={handleInputChange}
              placeholder=" " // Placeholder should be empty to prevent extra space
            />
            {errors.city && (
              <p
                className="text-red-500 text-left text-xs absolute"
                style={{ left: "10px", bottom: "-1.5rem" }} // Adjust positioning for error message
              >
                {errors.city}
              </p>
            )}
          </div>

          <div className="flex mb-10 space-x-4">
            <div className="flex-1 relative">
              <label
                className={`absolute transition-all duration-300 ease-in-out transform left-3 bg-[#121212] px-1 font-poppins ${
                  inputs.state
                    ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address"
                    : "top-1/2 text-[#4E4E4E] -translate-y-1/2 label-expand"
                }`}
                htmlFor="state"
                style={{
                  backgroundColor: theme.labelBg,
                  color: theme.pageText,
                  fontSize: inputs.state ? "1.25rem" : "0.875rem",
                
                  zIndex: 1, // Ensure label stays above other elements
                }}
              >
                {t("state")}
              </label>
              <input
                type="text"
                id="state"
                className={`input-address block w-full h-[55px] font-poppins rounded-md border-2 border-[#EBECF0] shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                  inputs.state && "text-[#FFFFFF] border-black"
                }`}
                style={{
                  backgroundColor: theme.inputBg,
                  borderColor: inputs.state
                    ? theme.inputBorderFilled
                    : theme.inputBorderEmpty,
                  color: theme.pageText,
                  paddingTop: "0.75rem", // Adjusted padding for vertical centering
                  paddingBottom: "0.75rem", // Ensures equal padding on top and bottom
                  lineHeight: "1.25rem", // Line height to help with vertical centering
                  boxSizing: "border-box", // Includes padding and border in the element's total width and height
                }}
                value={inputs.state}
                onChange={handleInputChange}
                placeholder=" " // Placeholder should be empty to prevent extra space
              />
              {errors.state && (
                <p
                  className="text-red-500 text-left text-xs absolute"
                  style={{ left: "10px", bottom: "-1.5rem" }} // Adjust positioning for error message
                >
                  {errors.state}
                </p>
              )}
            </div>

            <div className="flex-1 relative">
              <label
                className={`absolute transition-all duration-300 ease-in-out transform left-3 bg-[#121212] px-1 font-poppins ${
                  inputs.zipCode
                    ? "-top-2.5 text-[#FFFFFF] scale-75 label-shrink-address"
                    : "top-1/2 text-[#FFFFFF] -translate-y-1/2 label-expand"
                }`}
                htmlFor="zipCode"
                style={{
                  backgroundColor: theme.labelBg,
                  color: theme.pageText,
                  fontSize: inputs.zipCode ? "1.25rem" : "0.875rem",
                 
                  zIndex: 1, // Ensure label stays above other elements
                }}
              >
               {t("zipCode")}
              </label>
              <input
                type="tel"
                id="zipCode"
                className={`input-address block w-full h-[55px] font-poppins rounded-md border-2 border-[#EBECF0] shadow-sm focus:ring-0  sm:text-sm pt-2 pb-2 pl-3 pr-3 ${
                  inputs.zipCode && "text-[#4E4E4E] border-black"
                }`}
                style={{
                  backgroundColor: theme.inputBg,
                  borderColor: inputs.zipCode
                    ? theme.inputBorderFilled
                    : theme.inputBorderEmpty,
                  color: theme.pageText,
                  paddingTop: "0.75rem", // Adjusted padding for vertical centering
                  paddingBottom: "0.75rem", // Ensures equal padding on top and bottom
                  lineHeight: "1.25rem", // Line height to help with vertical centering
                  boxSizing: "border-box", // Includes padding and border in the element's total width and height
                }}
                value={inputs.zipCode}
                onChange={handleInputChange}
                placeholder=" " // Placeholder should be empty to prevent extra space
              />
              {errors.zipCode && (
                <p
                  className="text-red-500 text-left text-xs absolute"
                  style={{ left: "10px", bottom: "-1.5rem" }} // Adjust positioning for error message
                >
                  {errors.zipCode}
                </p>
              )}
            </div>
          </div>

          <div className="flex justify-between items-center mb-2">
            <div className="flex justify-center items-center w-full mb-4">
              <button
                type="button"
                onClick={handleCancel}
                className="font-poppins text-base font-medium leading-5 tracking-tighter text-center"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  letterSpacing: "-0.1px",
                  textAlign: "center",
                }}
              >
                {t("cancel")}
              </button>
            </div>
          </div>
          <div className="flex justify-center items-center mb-4 w-full">
            <div
              onClick={handleSave}
              className={`poppins-bold h-[51px] p-4 w-full mx-4 text-white text-center rounded-md shadow-md cursor-pointer font-poppins ${
                !isFormFilled ? "blur-bg" : "default-bg"
              }`}
               style= {layout?.buttonStyle }
            >
             {!!address ? t("update") : t("add")}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BillingAddressScreen;
